import React from "react";
import i18n from "utils/i18n";
import ThemedBlock from 'components/atoms/ThemedBlock'
import Form, { createTimeOptions } from 'components/molecules/Form'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import { FormFieldsConstants } from 'utils/constants/form-constants'
import PreviewTimeslotKind from 'scenes/management/timeslots/timeslot_kind/_components/PreviewTimeslotKind'
import { createTimeslotKindTimeOptions } from 'utils/helper/management/TimeslotKindOptions'
import VStack from 'components/atoms/stack/VStack'

const ManagementTimeslotKindAdvancedTab = ( { saveForm, updateTimeslotKind, timeslotKind, isSaving }) => {
	
	const formFields = [];
	
	formFields.push( {
		name: 'show_time',
		label: i18n.t('management:form.show_time.title'),
		type: FormFieldsConstants.SELECT_ACTIVE
	});
	
	formFields.push( {
		name: 'show_capacity',
		label: i18n.t('management:form.show_capacity.title'),
		type: FormFieldsConstants.SELECT_ACTIVE
	});
	
	formFields.push( {
		name: 'show_capacity_in_timeslot',
		label: i18n.t('management:form.show_capacity_in_timeslot.title'),
		type: FormFieldsConstants.SELECT_ACTIVE
	});
	
	formFields.push( {
		name: 'can_only_select_one_per_day',
		label: i18n.t('management:form.can_only_select_one_per_day.title'),
		type: FormFieldsConstants.SELECT_ACTIVE
	});
	formFields.push( {
		name: 'can_overlap_with_booking',
		label: i18n.t('management:form.can_overlap_with_booking.title'),
		type: FormFieldsConstants.SELECT_ACTIVE
	});
	
	formFields.push( {
		name: 'can_book_from',
		label: i18n.t('management:form.can_book_from.title'),
		type: FormFieldsConstants.TIMESLOT_TIME_SELECT,
		options: createTimeslotKindTimeOptions({ present: false })
	});
	
	formFields.push( {
		name: 'can_book_until',
		label: i18n.t('management:form.can_book_until.title'),
		type: FormFieldsConstants.TIMESLOT_TIME_SELECT,
		options: createTimeslotKindTimeOptions()
	});
	
	formFields.push( {
		name: 'can_cancel_until',
		label: i18n.t('management:form.can_cancel_until.title'),
		type: FormFieldsConstants.TIMESLOT_TIME_SELECT,
		options: createTimeslotKindTimeOptions()
	});
	
	// QR code scan
	const qrScanPresenceTimeFromOptions = [ createTimeOptions( 'always', { translation: `management:form.time_select.always` }) ];
	const qrScanPresenceTimeUntilOptions = [ createTimeOptions( 'always', { translation: `management:form.time_select.always` }) ];
	
	for( let min = 5; min <= 60; min += 5 ) {
		qrScanPresenceTimeFromOptions.push( createTimeOptions( `minute:${min}:-` ) );
		qrScanPresenceTimeUntilOptions.push( createTimeOptions( `minute:${min}:+` ) );
	}
	
	formFields.push( {
		name: 'can_scan_presence_qr_code',
		label: i18n.t( 'management:form.can_scan_presence_qr_code.title' ),
		type: FormFieldsConstants.SELECT_ACTIVE
	} );
	
	formFields.push( {
		name: 'can_scan_presence_qr_code_from',
		label: i18n.t('management:form.can_scan_presence_qr_code_from.title'),
		type: FormFieldsConstants.SELECT,
		options: qrScanPresenceTimeFromOptions
	});
	
	formFields.push( {
		name: 'can_scan_presence_qr_code_until',
		label: i18n.t('management:form.can_scan_presence_qr_code_until.title'),
		type: FormFieldsConstants.SELECT,
		options: qrScanPresenceTimeUntilOptions
	});
	
	
	if( timeslotKind?.instructions_link === null ){
		timeslotKind.instructions_link = '';
	}
	
	formFields.push( {
		name: 'instructions_link',
		label: i18n.t('management:form.instructions_link.title'),
		type: FormFieldsConstants.TEXT,
		disabled: false
	});
	
	formFields.push( {
		name: 'extra_parameters',
		label: i18n.t('management:form.extra_parameters.title'),
		type: FormFieldsConstants.TEXT,
		disabled: true
	});
	
	return (
		<VStack>
			<PreviewTimeslotKind
				timeslotKind={ timeslotKind }
			/>
			
			<ThemedBlock
				shadow
				mediumPadding>
				
				<Form
					values={ timeslotKind }
					fields={ formFields }
					onChange={ updateTimeslotKind }
					onSubmit={ saveForm }
					disabled={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.TIMESLOTS ) || isSaving }
					forceSaveButton={ true }
				/>
			</ThemedBlock>
		</VStack>
	);
}


export default ManagementTimeslotKindAdvancedTab
